//
// Generated class EventPhase
//

/// <reference path="EventPhase_ManagedObject.ts" />

class EventPhase extends EventPhase_ManagedObject
{

}
